import { z } from 'zod'

export const zPriceTypeEnum2 = z.enum([
  'Agreement',
  'AgreementGroup',
  'Appropriation',
  'PriceList',
  'PositiveList',
  'Campaign',
])

export type PriceTypeEnum2Schema = z.infer<typeof zPriceTypeEnum2>
